// TODO: @Flemin, Add Proptypes and remove this eslint rule disable
import React from 'react';
import { useSelector } from 'react-redux';
import { useLocalize } from '@saviynt/common';
import {
  Box,
  Button,
  Icon,
  MobileDrawer,
  Popover,
  Typography,
} from '@saviynt/design-system';
import PropTypes from 'prop-types';

import {
  SCREEN_SIZE_MOBILE_XLARGE,
  SCREEN_WIDTH_QUERIES,
} from '../../../utils/constant';
import { useInvertedLocalize } from '../../../utils/localization';
import { ACTION_BUTTON_KINDS } from '../constant';

import { invertedMessages } from './messages';

import '../CertsActionPopover/CertsActionPopover.css';
import './CertsSaviActionPopover.css';

function CertsSaviActionPopover({
  kind,
  handleClick,
  onClose,
  isOpen,
  trigger,
  placement,
  saviRespondedReason,
  getTypeActEntRole,
  getCertIconKind,
  getColKey,
}) {
  const localize = useLocalize();

  const { mediaQueryValue } = useSelector(
    (state) => state?.certifications?.details?.global
  );
  const l = useInvertedLocalize(invertedMessages);

  const TextMapping = {
    [ACTION_BUTTON_KINDS.APPROVE]: {
      title: 'Reasons for Smart Approval',
      buttonText: 'Cancel Approval',
      iconKind: 'CheckCircleOutline',
    },
    [ACTION_BUTTON_KINDS.REJECT]: {
      title: 'Reasons for Smart Rejection',
      buttonText: 'Cancel Rejection',
      iconKind: 'AlertCriticalOutline',
      color: 'critical-500',
    },
  };

  const mobileXlargeQuery = SCREEN_WIDTH_QUERIES.find(
    (item) => item.label === SCREEN_SIZE_MOBILE_XLARGE
  );
  const isMobileXlargeWidth = mobileXlargeQuery.value <= mediaQueryValue;

  const getPopoverContent = () => (
    <Box className='Savi-Companion-Action-Popover--ContentWrapper'>
      {isMobileXlargeWidth && (
        <div className='Savi-Companion-Action-Mobile-Drawer-Header'>
          <Icon kind={getCertIconKind} color='navy-900' size='medium' />
          <Typography kind='h3'>
            {/* eslint-disable-next-line react/jsx-one-expression-per-line */}
            {getTypeActEntRole}:{getColKey}
          </Typography>
        </div>
      )}
      <div className='Savi-Companion-Action-Popover--DisplayFlex Title'>
        <Icon kind='SaviCompanionGradient' size='medium' />
        <Typography kind='h3'>{TextMapping[kind].title}</Typography>
      </div>
      {saviRespondedReason && saviRespondedReason.length > 0 ? (
        saviRespondedReason.map((reason) => {
          const reasonKeys = Object.keys(reason);
          const messagePropertyKey =
            reasonKeys.length > 0 ? reasonKeys[0] : undefined;
          const firstKeyValue =
            reason[messagePropertyKey]?.map((value) => value.toFixed(2)) || [];

          return (
            <div className='Savi-Companion-Action-Popover--DisplayFlex Reasons'>
              <div>
                <Icon
                  kind={TextMapping[kind].iconKind}
                  color={TextMapping[kind].color}
                  size='xSmall'
                />
              </div>
              <Typography kind='body2'>
                {/* TODO: regression testing needed here for localize changes */}
                {messagePropertyKey &&
                  localize(messagePropertyKey, firstKeyValue)}
              </Typography>
            </div>
          );
        })
      ) : (
        <div className='Savi-Companion-Action-Popover--DisplayFlex Reasons'>
          <Typography kind='body2'>{l('No data available')}</Typography>
        </div>
      )}
      <div className='Savi-Companion-Action-Popover--DisplayFlex Action-Button-Wrapper'>
        <Button
          type='button'
          kind='subtle'
          size='large'
          className='Cancel'
          onClick={() => {
            handleClick('');
            onClose();
          }}>
          <Typography kind='body3-bold' className='Text'>
            {TextMapping[kind].buttonText}
          </Typography>
        </Button>
        <Button
          className='Action-Button--MarginLeft-Auto GotIt'
          type='button'
          kind='filled'
          size='large'
          onClick={() => onClose(false)}>
          <Typography kind='body3-bold' className='Text'>
            {l('Got It')}
          </Typography>
        </Button>
      </div>
    </Box>
  );

  return (
    <section>
      <Box tag='div' className='CertsActionPopover-contextWrapper'>
        <Popover
          isPortalEnabled
          trigger={trigger}
          popoverContent={getPopoverContent()}
          isOpen={isOpen && !isMobileXlargeWidth}
          setIsOpen={onClose}
          placement={placement}
        />
      </Box>
      {isMobileXlargeWidth && (
        <MobileDrawer
          isOpen={isOpen}
          setIsOpen={onClose}
          content={getPopoverContent()}
          isSwipeEnabled
        />
      )}
    </section>
  );
}

CertsSaviActionPopover.propTypes = {
  kind: PropTypes.string.isRequired,
  handleClick: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired,
  isOpen: PropTypes.bool.isRequired,
  trigger: PropTypes.element.isRequired,
  placement: PropTypes.string.isRequired,
  // TODO: @Flemin, update this proptype
  // eslint-disable-next-line react/forbid-prop-types
  saviRespondedReason: PropTypes.any,
  getTypeActEntRole: PropTypes.func.isRequired,
  getCertIconKind: PropTypes.func.isRequired,
  getColKey: PropTypes.func.isRequired,
};

CertsSaviActionPopover.defaultProps = { saviRespondedReason: null };

export default CertsSaviActionPopover;
